import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const LIST_VIEW_SEARCH_PARAM = 'view';

export const MESSAGING_LIST_VIEWS = ['inbox', 'unread', 'archived'] as const;

export type MessagingListView = (typeof MESSAGING_LIST_VIEWS)[number];

const DEFAULT_LIST_VIEW: MessagingListView = 'inbox';

const isMessagingListView = (value: string | null): value is MessagingListView =>
  MESSAGING_LIST_VIEWS.some((listView) => listView === value);

export default function useMessagingListView() {
  const [searchParams, setSearchParams] = useSearchParams();
  const listViewParam = searchParams.get(LIST_VIEW_SEARCH_PARAM);
  const listView = isMessagingListView(listViewParam) ? listViewParam : DEFAULT_LIST_VIEW;

  const setListView = useCallback(
    (nextListView: MessagingListView) => {
      setSearchParams((currentParams) => {
        const nextParams = new URLSearchParams(currentParams);
        if (nextListView === DEFAULT_LIST_VIEW) {
          nextParams.delete(LIST_VIEW_SEARCH_PARAM);
        } else {
          nextParams.set(LIST_VIEW_SEARCH_PARAM, nextListView);
        }

        return nextParams;
      });
    },
    [setSearchParams],
  );

  return { listView, setListView };
}
